import React from 'react';
import './Stats.css'; // Reusing stat block styles

const SavingThrows = ({ savingThrows }) => {
    return (
        <div className="stat-block saving-throws">
            <h3>Saving Throws</h3>
            <div className="saving-throws-grid">
                {Object.entries(savingThrows).map(([ability, data]) => (
                    <div key={ability} className={`save-row ${data.isProficient ? 'proficient' : ''}`}>
                        <div className="save-label">
                            <span className="save-prof-indicator">{data.isProficient ? '●' : '○'}</span>
                            {ability.charAt(0).toUpperCase() + ability.slice(1)}
                        </div>
                        <div className="save-value">
                            {data.modifier >= 0 ? '+' : ''}{data.modifier}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default SavingThrows;
